document.addEventListener("DOMContentLoaded", function () {
  const buttonClasses = ["button-1", "button-2", "button-3", "banner-button-1"];

  buttonClasses.forEach(function (className) {
    const buttons = document.querySelectorAll("." + className);

    buttons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();

        const targetId = this.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  });
});